import React, { MouseEventHandler } from 'react';
import { LanguageText, StyledLanguageToggle } from './styles';

export type LanguageToggleProps = {
  text: string;
  url: string;
  onClick?: MouseEventHandler;
};

const LanguageToggle: React.FC<LanguageToggleProps> = ({ text, url, onClick }) => {
  return (
    <StyledLanguageToggle href={url} onClick={onClick} removeVisitedStyle>
      <LanguageText>{text}</LanguageText>
    </StyledLanguageToggle>
  );
};

export default LanguageToggle;
